export const claimsQueryKeys = {
  all: ['claims'] as const,
  campaigns: () => [...claimsQueryKeys.all, 'campaigns'] as const,
  approvalRequestsBase: (campaignId: string) => [...claimsQueryKeys.all, 'approval-requests', campaignId] as const,
  approvalRequests: (campaignId: string, status?: string, page?: number, pageSize?: number) =>
    [...claimsQueryKeys.approvalRequestsBase(campaignId), status, page, pageSize] as const,
};
